<mat-checkbox [formControl]="control" (change)="onChange($event)">
  <div class="text">{{ label }}</div>
</mat-checkbox>
